import React from 'react';
import { ink } from '../../primitives.js';

const h = React.createElement;

/**
 * Step dots: lime done, a gold diamond for the current step, track for the rest.
 *
 * @param {object} p
 * @param {number} [p.done]
 * @param {number} [p.total]
 * @param {number} [p.cur]
 */
export function Dots({ done = 0, total = 5, cur }) {
  const c = cur == null ? done : cur;
  return h('span', { style: { display: 'inline-flex', gap: 3, alignItems: 'center' }, title: `${done} of ${total} steps` },
    Array.from({ length: total }, (_, i) => h('span', { key: i + (i + 1 === c ? ':cur' : ''), className: i + 1 === c ? 'gx-pop-dot' : undefined, style: { width: 7, height: 7, borderRadius: i + 1 === c ? 1 : '50%', background: i < done ? 'var(--lime)' : i + 1 === c ? 'var(--gold)' : 'var(--track)', border: ink(1), boxSizing: 'border-box', transform: i + 1 === c ? 'rotate(45deg)' : 'none' } })));
}
